module.exports = __webpack_public_path__ + "img/southampton.85f89563.png";